import React, { useState, useEffect, FormEvent } from 'react';
import { FiPhone, FiSend } from 'react-icons/fi';
import axios from 'axios';
import { apiClient } from '../config/apiConfig';

interface Category {
    categorieId?: number;
    name: string;
    imageUrl?: string;
}

const AdminCategory: React.FC = () => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [name, setName] = useState('');
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [editId, setEditId] = useState<number | null>(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await apiClient.get('/Categories/GetCategories');
            setCategories(res.data);
        } catch (err) {
            console.error('Failed to fetch categories', err);
        }
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        if (!name) return alert('Enter category name');

        try {
            const formData = new FormData();
            formData.append("name", name);  // matches [FromForm] string name
            if (imageFile) {
                formData.append("imageFile", imageFile);  // matches IFormFile imageFile
            }
            if (editId) {
                formData.append("categorieId", editId.toString()); // matches [FromForm] int? categorieId
            }

            await apiClient.post("/Categories/AddOrUpdateCategory", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            alert(editId ? "Category updated!" : "Category added!");
            setEditId(null);
            setName('');
            setImageFile(null);
            fetchCategories();
        } catch (err) {
            console.error(err);
            alert('Operation failed');
        }
    };
    const handleEdit = (cat: Category) => {
        setName(cat.name);
        setEditId(cat.categorieId || null);
    };

    const handleDelete = async (id?: number) => {
        if (!id) return;
        if (!window.confirm('Are you sure to delete this category?')) return;

        try {
            await apiClient.delete(`/Categories/DeleteCategory/${id}`);
            alert('Category deleted');
            fetchCategories();
        } catch (err) {
            console.error(err);
            alert('Failed to delete category. Make sure no products are linked to it.');
        }
    };

    return (
        <div className="container mt-4">
            {/* --- Header --- */}
            <div className="py-1 bg-primary">
                <div className="container">
                    <div className="row no-gutters d-flex align-items-start align-items-center px-md-0">
                        <div className="col-lg-12 d-block">
                            <div className="row d-flex">
                                <div className="col-md pr-4 d-flex topper align-items-center">
                                    <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiPhone size={12} color="white" /></div>
                                    <span className="text">+91 9148761750</span>
                                </div>
                                <div className="col-md pr-4 d-flex topper align-items-center">
                                    <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiSend size={12} color="white" /></div>
                                    <span className="text">care@fhome.shop</span>
                                </div>
                                <div className="col-md-5 pr-4 d-flex topper align-items-center text-lg-right">
                                    <span className="text">3-5 Business days delivery &amp; Free Returns</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
                <div className="container">
                    <a className="navbar-brand d-flex align-items-center" href="/">
                        <img
                            src="/images/fhome-logo.jpg"
                            alt=""
                            style={{ height: "55px", marginRight: "8px", borderRadius: "50%", width: "80px" }}
                        />
                        <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
                    </a>

                    <div className="collapse navbar-collapse" id="ftco-nav">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item active"><a href="/admin/categories" className="nav-link">AdminCategories</a></li>
                            <li className="nav-item active"><a href="/admin/deal-of-the-day" className="nav-link">DealOfTheDay</a></li>
                            <li className="nav-item"><a href="/admin" className="nav-link">Admin Products</a></li>
                            <li className="nav-item"><a href="/admin/orders" className="nav-link">Admin Orders</a></li>
                        </ul>
                    </div>
                </div>
            </nav>
            {/* --- Form --- */}
            <h3>{editId ? 'Edit Category' : 'Add New Category'}</h3>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label>Name</label>
                    <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label>Image (optional)</label>
                    <input type="file" className="form-control" onChange={(e) => setImageFile(e.target.files?.[0] ?? null)} />
                </div>
                <button type="submit" className="btn btn-primary">
                    {editId ? 'Update Category' : 'Add Category'}
                </button>
                {editId && (
                    <button type="button" className="btn btn-secondary ml-2" onClick={() => { setEditId(null); setName(''); setImageFile(null); }}>
                        Cancel
                    </button>
                )}
            </form>

            {/* --- Category List --- */}
            <h4 className="mt-4">Existing Categories</h4>
            <ul className="list-group">
                {categories.map((cat) => (
                    <li key={cat.categorieId} className="list-group-item d-flex justify-content-between align-items-center">
                        <span>
                            {cat.name} {cat.imageUrl && <img src={cat.imageUrl} alt={cat.name} width={50} className="ml-2" />}
                        </span>
                        <span>
                            <button className="btn btn-sm btn-info mr-2" onClick={() => handleEdit(cat)}>Edit</button>
                            <button className="btn btn-sm btn-danger" onClick={() => handleDelete(cat.categorieId)}>Delete</button>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AdminCategory;

